import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import { intlMessage } from 'constants/propTypes';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';

import './Badge.scss';

const Badge = ({
  children,
  className,
  danger,
  disabled,
  icon,
  info,
  light,
  message,
  notice,
  size = 'sm',
  solid,
  warn,
}) =>
  !children && !message ? null : (
    <div className={withMods('badge', { [size]: size, light, warn, danger, info, disabled, solid, notice }, className)}>
      {icon && <Isvg src={icon} />}
      <span className="badge__text">{children || <Message as="text" message={message} />}</span>
    </div>
  );

Badge.propTypes = {
  className: PropTypes.string,
  light: PropTypes.bool,
  icon: PropTypes.string,
  info: PropTypes.bool,
  warn: PropTypes.bool,
  danger: PropTypes.bool,
  notice: PropTypes.bool,
  solid: PropTypes.bool,
  disabled: PropTypes.bool,
  message: intlMessage,
  children: PropTypes.node,
  size: PropTypes.oneOf(['xs', 'sm', 'regular', 'md', 'lg', 'xl']),
};

export default Badge;
